import mainImg from "../../../assets/j-profile.png"; 


import thumb1 from "../../../assets/j-profile.png";
import thumb2 from "../../../assets/j-profile.png";


export const products = [
  

  {
  code: "7050",
  name: "ALUMINIUM J PROFILE HANDLE",
  category: "aluminium-profile",

  mainImage: mainImg,
  thumbnails: [thumb1, thumb2],

  price: "₹250",
  oldPrice: "₹399",
  sku: "7050",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/9650100908?text=Aluminium J Profile Handle Inquiry",

  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  short:
    "Aluminium J Profile Handle is a modern and elegant handle solution designed for modular kitchens, wardrobes, and furniture cabinets. Its sleek profile creates a handle-less appearance while ensuring a comfortable grip and smooth operation. Manufactured from premium-grade aluminium, it offers durability, corrosion resistance, and a stylish finish suitable for contemporary interiors.",

  features: [
    "Premium quality aluminium construction",
    "Modern handle-less design",
    "Strong and durable profile",
    "Corrosion and rust resistant",
    "Easy installation on cabinet shutters",
    "Suitable for kitchens, wardrobes, and furniture"
  ],

  specifications: [
    { label: "Material", value: "Aluminium" },
    { label: "Type", value: "J Profile Handle" },
    { label: "Application", value: "Kitchen & Wardrobe Shutters" },
    { label: "Finish", value: "Matt / Anodized Finish" }
  ],

  specTable: [
    {
      item: "J Profile Handle",
      code: "7050",
      size: "3 Meter",
      finish: "Black Matt"
    },
    {
      item: "J Profile Handle",
      code: "7051",
      size: "3 Meter",
      finish: "Silver"
    },
    {
      item: "J Profile Handle",
      code: "7052",
      size: "3 Meter",
      finish: "Champagne"
    }
  ],

  faq: [
    {
      question: "What is a J Profile Handle?",
      answer:
        "A J Profile Handle is an aluminium profile fixed to cabinet shutters that provides a clean and handle-less look while ensuring easy opening."
    },
    {
      question: "Where can J Profile Handles be used?",
      answer:
        "They are widely used in modular kitchens, wardrobes, drawers, and modern furniture."
    },
    {
      question: "Is aluminium J Profile durable?",
      answer:
        "Yes, it is manufactured from high-quality aluminium, making it strong, lightweight, and corrosion-resistant."
    },
    {
      question: "What finishes are available?",
      answer:
        "J Profile Handles are commonly available in Black, Silver, Champagne, and other premium finishes."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it can be easily fitted to cabinet shutters by professional installers."
    }
  ]}]
